module.exports = __webpack_public_path__ + "img/question-icon-1.10598ee5.png";